import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="asset-grid"
export default class extends Controller {
  connect() {
    if(window.innerWidth >= 1023){
      const imgs = document.querySelector('.multi-pane-video__asset-grid').querySelectorAll('img');
      imgs.forEach(img => {
        img.addEventListener('click', () => {
          img.classList.toggle('expanded');
        })
      });
    }
  }

}
